export default "__VITE_ASSET__DHe5LNCf__"